const PopUp = () => {
  return (
    <a
      href="https://myservices.org.in/pricing/online-travel-portal"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed top-[15%] ff-sans right-3 bg-green-500 z-10 text-white px-4 py-2 rounded shadow-lg hover:scale-105 transition-all duration-300 popup-animate popup-float"
    >
      Book Now
    </a>
  );
};

export default PopUp;
